import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Music, Tags, ListMusic } from 'lucide-react';
import AdminAudioLibraryPage from './AdminAudioLibraryPage';
import AdminAudioTagsPage from './AdminAudioTagsPage';
import AdminAudioCollectionsPage from './AdminAudioCollectionsPage';
import { useAuth } from '../../context/AuthContext';
import { t } from '../../lib/i18n';

const AdminAudioPage = () => {
  const { language } = useAuth();

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold font-cinzel flex items-center gap-2">
            <Music className="h-6 w-6" />
            {t('admin_audio_title', language)}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            {t('admin_audio_subtitle', language)}
          </p>
        </div>

        <Tabs defaultValue="library">
          <TabsList className="mb-4">
            <TabsTrigger value="library" className="flex items-center gap-1.5">
              <Music className="h-4 w-4" />
              {t('admin_audio_library', language)}
            </TabsTrigger>
            <TabsTrigger value="tags" className="flex items-center gap-1.5">
              <Tags className="h-4 w-4" />
              {t('admin_audio_tags', language)}
            </TabsTrigger>
            <TabsTrigger value="collections" className="flex items-center gap-1.5">
              <ListMusic className="h-4 w-4" />
              {t('admin_audio_collections', language)}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="library">
            <AdminAudioLibraryPage />
          </TabsContent>

          <TabsContent value="tags">
            <AdminAudioTagsPage />
          </TabsContent>

          <TabsContent value="collections">
            <AdminAudioCollectionsPage />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
};

export default AdminAudioPage;
